import * as React from "react"
import NavBar from "../components/NavBar";
import {
    addCommas,
    handleBorderColor,
    HandlerShowMessage,
    HandleValidationMethod,
    removeNonNumeric
} from "../assets/js/main";
import {PatternFormat} from "react-number-format";
import {Autocomplete, Box, CircularProgress, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setValidations} from "../redux/public/actions";
import {setLoading} from "../redux/loading/actions";
import HandleFetchData from "../plugin/HandleFetchData";
import {setCityIDSender, setMobileNumberSender} from "../redux/singleOrder/sender/actions";
import {useLocation} from "react-router-dom";

const Complaint = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const location = useLocation();
    const {fetchData} = HandleFetchData()
    const {showMessage} = HandlerShowMessage();
    const {validationMethod} = HandleValidationMethod()

    const trackingNumRef = React.useRef()
    const agentFullNameRef = React.useRef()
    const agentMobileNumRef = React.useRef()
    const orderNumRef = React.useRef()
    const stateAndCityRef = React.useRef()
    const typeRef = React.useRef()

    const [_loading, set_Loading] = React.useState(false);

    const [trackingNum , setTrackingNum] = React.useState()
    const [orderId, setOrderId] = React.useState()
    const [type, setType] = React.useState()
    const [typeList, setTypeList] = React.useState([])
    const [desc, setDesc] = React.useState()
    const [agentFullName, setAgentFullName] = React.useState()
    const [cityId, setCityId] = React.useState()
    const [agentMobileNum, setAgentMobileNum] = React.useState()
    const [isSolve, setIsSolve] = React.useState(false)
    const [listStateAndCity, setListStateAndCity] = React.useState([])
    const [textStateAndCity, setTextStateAndCity] = React.useState('')


    React.useEffect(() => {
        handleGetConstants()
        handleGetStateAndCity()
    }, [])

    const validationInput = (event) => {
        event.preventDefault();
        if(!agentFullName){
            validationMethod(agentFullNameRef, 'agentFullName', t("error.t4"))
        }else if(!agentMobileNum){
            validationMethod(agentMobileNumRef, 'agentMobileNum', t("error.t6"))
        } else if (agentMobileNum?.length !== 11 || !agentMobileNum.startsWith("09")) {
            validationMethod(agentMobileNumRef, 'agentMobileNum', t("error.t7"))
        }else if(!orderId && !trackingNum){
            validationMethod(trackingNumRef, 'trackingNum', t("error.t41"))
        }else if(!trackingNum && !orderId){
            validationMethod(orderNumRef, 'orderNum', t("error.t40"))
        }else if(!type){
            validationMethod(typeRef, 'type', t("error.t57"))
        }else if(!cityId){
            validationMethod(stateAndCityRef, 'stateAndCity', t("error.t58"))
        }else{
            handleSubmit()
        }
    }

    const handleSubmit = async () => {
        dispatch(setValidations(null))
        dispatch(setLoading(true))
        let fetch = await fetchData('ticketing', 'POST', '/v1/Complaint', {
                "trackingNumber": trackingNum,
                "orderId": orderId,
                "type": type,
                "description": desc,
                "agentFullName": agentFullName,
                "cityId":cityId,
                "agentMobileNumber": agentMobileNum,
                "isSolve": isSolve
            },
            "application/json",'', 'postex'
        )
        showMessage(fetch?.status)
        if(fetch?.success){
            setTimeout(() => {
                window.location.reload();
            }, 2000)
        }
        dispatch(setLoading(false))
    }

    const handleGetConstants = async () => {
        let fetch = await fetchData('ticketing', 'GET', '/v1/Constants', '',
            "application/json",{"id": "23"}, 'postex'
        )
        setTypeList(fetch?.data?.ComplaintTypes)
        // showMessage(fetch?.status)
        // if(fetch?.success){
        //     navigate({
        //         pathname: "/wallet",
        //         search: location?.search
        //     });
        // }
        dispatch(setLoading(false))
    }

    // متد دریافت لیست استان ها
    const handleGetStateAndCity = async (e) => {
        set_Loading(true)
        let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
            "term": e
        }, 'postex')
        setListStateAndCity(fetch?.data)
        const item = fetch?.data.find(e => e.id === '1-1')
        set_Loading(false)
    }

    const handleSetInfoStateAndCity = (value, flag) => {
        let name = e => value?.name?.split('-')[e]
        let id = e => value?.id?.split('-')[e]
        setCityId(id(1) || '')
    }


    return(
        <>

            {(location.pathname === '/complaint' || location.pathname === '/divar/complaint') &&
                <NavBar blue back/>
            }

            <div className="container">
                <div className="withdrawalRequestPage">
                    <div className="titlePage">
                        <h1>{t("complaint.t1")}</h1>
                    </div>


                    <div className="form">
                        <form onSubmit={validationInput}>
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className="required">{t("complaint.t2")}</label>
                                        <input type="text" name="agentFullName" id="agentFullName"
                                               style={handleBorderColor(selector?.public?.validations?.agentFullName)}
                                               value={agentFullName} ref={agentFullNameRef}
                                               onChange={e => setAgentFullName(e.target.value)}/>
                                        {
                                            selector?.public?.validations?.agentFullName &&
                                            <p className="error">{selector?.public?.validations?.agentFullName}</p>
                                        }
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className="required">{t("complaint.t5")}</label>
                                        <input type="text" name="agentMobileNum" className="numeric" ref={agentMobileNumRef}
                                               style={handleBorderColor(selector?.public?.validations?.agentMobileNum)}
                                               value={agentMobileNum} id="agentMobileNum"
                                               inputMode='numeric'
                                               onChange={e => e?.target?.value?.length <= 11 &&
                                                   setAgentMobileNum(removeNonNumeric(e.target.value))
                                               }
                                        />
                                        {
                                            selector?.public?.validations?.agentMobileNum &&
                                            <p className="error">{selector?.public?.validations?.agentMobileNum}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className={!orderId ? "required" : ""}>{t("complaint.t3")}</label>
                                        <input type="text" name="trackingNum" id="trackingNum"
                                               style={handleBorderColor(selector?.public?.validations?.trackingNum)}
                                               value={trackingNum} ref={trackingNumRef}
                                               onChange={e => setTrackingNum(removeNonNumeric(e.target.value))}/>
                                        {
                                            selector?.public?.validations?.trackingNum &&
                                            <p className="error">{selector?.public?.validations?.trackingNum}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className={!trackingNum ? "required" : ""}>{t("complaint.t4")}</label>
                                        <input type="text" name="orderNum" id="orderNum"
                                               style={handleBorderColor(selector?.public?.validations?.orderNum)}
                                               value={orderId} ref={orderNumRef}
                                               onChange={e => setOrderId(removeNonNumeric(e.target.value))}/>
                                        {
                                            selector?.public?.validations?.orderNum &&
                                            <p className="error">{selector?.public?.validations?.orderNum}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className="required">{t("complaint.t8")}</label>
                                        <select aria-label="Default select example" value={type} id="type" ref={typeRef}
                                                onChange={e => setType(e.target.value)}
                                                style={handleBorderColor(selector?.public?.validations?.type)}
                                        >
                                            <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                                            {
                                                typeList?.map(item => item?.code != 1 && <option  value={item?.code}
                                                                           key={item?.code}>{item?.title}</option>)
                                            }
                                        </select>
                                        {
                                            selector?.public?.validations?.type &&
                                            <p className="error">{selector?.public?.validations?.type}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <label className="required">{t("singleOrder.sender.t19")}</label>
                                    <Autocomplete
                                        inputValue={textStateAndCity}
                                        defaultValue={textStateAndCity}
                                        noOptionsText={t("autoComplete.t1")}
                                        ref={stateAndCityRef}
                                        id="city-state-sender"
                                        disablePortal
                                        autoHighlight
                                        loading={_loading}
                                        onChange={(e, value, reason) => {
                                            if (reason === 'clear') {
                                                setTextStateAndCity('')
                                                handleSetInfoStateAndCity(null, 'sender')
                                            } else {
                                                setTextStateAndCity(value?.name)
                                                handleSetInfoStateAndCity(value, 'sender')
                                            }
                                        }}
                                        options={listStateAndCity || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                       hiddenLabel
                                                       size="small"
                                                       style={handleBorderColor(selector?.public?.validations?.stateAndCity)}
                                                       placeholder={t("singleOrder.sender.t24")}
                                                       onChange={(event) => {
                                                           setTextStateAndCity(event?.target?.value)
                                                           event?.target?.value?.length > 1 ? handleGetStateAndCity(event?.target?.value) : handleSetInfoStateAndCity(null, 'sender')
                                                       }}
                                                       InputProps={{
                                                           ...params.InputProps,
                                                           endAdornment: (
                                                               <React.Fragment>
                                                                   {_loading ?
                                                                       <CircularProgress style={{margin: '0 5px'}}
                                                                                         size={20}/>
                                                                       : null}
                                                                   {params.InputProps.endAdornment}
                                                               </React.Fragment>
                                                           ),
                                                       }}
                                            />}
                                    />
                                    {
                                        selector?.public?.validations?.stateAndCity &&
                                        <p className="error">{selector?.public?.validations?.stateAndCity}</p>
                                    }
                                </div>

                                <div className="col-12">
                                    <div className="input">
                                        <label>{t("complaint.t7")}</label>
                                        <textarea rows="5" value={desc} onChange={e => setDesc(e.target.value)} id="desc"/>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="btnGroup_yellow mb-0">
                                        <button type="submit" className="btnFill justify-content-center m-0" disabled={selector?.loading?.isLoading}>
                                            {
                                                selector?.loading?.isLoading ?
                                                    <Box sx={{display: 'flex'}}>
                                                        <CircularProgress size={20}/>
                                                    </Box>
                                                    :
                                                    <span>{t("withdrawalRequest.t10")}</span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Complaint;